var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hidden)?_c('div',{class:{ 'payment-list-title': true, loader: _vm.isLoading }},[_c('p',[_vm._v(_vm._s(_vm.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }